import {moment} from 'helpers';
import {put, select} from 'redux-saga/effects';
import {watch} from 'store/effects';
import {activities, calendar} from 'store';

export function * timer() {
  yield watch(calendar.activeTimer, function * (now, prev) {
    // save timer data
    if (prev && prev?.id !== now?.id) {
      // if activity was not deleted
      if (yield select(activities.activity, {id: prev.activity.id})) {
        yield put({
          type: 'ACTIVITIES_STATUS_UPDATE',
          id: prev.activity.id,
          contextDate: moment.unix(prev.ts),
          data: {result: prev.getResult()}
        });
      }
    }
  });
}
